import React, { Component } from 'react';
import ReactDOM from "react-dom";
import styled from "styled-components";
import StatusButton from './StatusButton';
import StatusButtonLetter from './StatusButtonLetter';
import {ChangeStatusLetter} from "../../Utils/ChangeStatusCostumer";
import { Dialog,DialogTitle,DialogContent,DialogActions,Button } from '@material-ui/core';

const Container=styled.div`
position: fixed;
top: 0;
left: 0;
bottom: 0;
right: 0;
display: grid;
flex-direction: column;
justify-items:center;
align-items: center;
background-color: rgba(0, 0, 0, 0.5);`;

const Modal=styled.div`
border-radius:15px;
display:grid;
grid-template-areas:auto auto/auto;
justify-items:center;
align-items:center;
position:relative;
background-color:white;`;

const ContainerButtons=styled.div`
display:grid;
grid-template-columns: repeat(11,auto);

@media screen and (max-width:1000px)
{
    grid-template-columns: repeat(4,auto);
    grid-template-rows: repeat(2,auto);
}

@media screen and (max-width:400px)
{
    grid-template-columns: repeat(3,auto);
    grid-template-rows: repeat(2,auto);
}
`;

const ButtonClose=styled.button`
border:none;
cursor:pointer;
outline:none;
background-color: white;
border-radius: 50%;
border-radius: initial 50px initial initial;
justify-self:end;
`;

const ContainerButton=styled.div`
margin:10px;
`;



const EditStatus=({open,close,customer})=>
{
    const {id,data}=customer;
    const {name}=data;
   
    const statuslist=
    [
        {color:"#fda634",letter:"",status:"annotated"},
        {color:"#fda634",letter:"TV",status:"confirming"},
        {color:"#fda634",letter:"T",status:"waiting"},
        {color:"#fda634",letter:"V",status:"waiting"},
        {color:"#61cf45",letter:"T",status:"coming"},
        {color:"#61cf45",letter:"V",status:"coming"},
        {color:"#61cf45",letter:"PB",status:"coming"},
        {color:"#61cf45",letter:"PA",status:"coming"},
        {color:"#ff1e06",letter:"",status:"no-info"},
    ]

    const OnClickWithLetter=(status,letter)=>
    {
        ChangeStatusLetter(id,status,letter);
        close();
    }


    return <Dialog open={open} onClose={close}>
       <DialogTitle style={{textAlign:"center"}}>{`Cambiar estado a ${name}`}</DialogTitle>
       <DialogContent>
        <ContainerButtons>
        {statuslist.map(option =>    
        {
            const {color,letter,status}=option

            return  <ContainerButton onClick={() => OnClickWithLetter(status,letter)}>
                          <StatusButtonLetter color={color} letter={letter} />
                    </ContainerButton>
        })}
        </ContainerButtons>
       </DialogContent>
    </Dialog>
}

export default EditStatus;
